import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { DateTimePipe } from './date-time.pipe';
import { MaterialModule } from './material.module';

const modules = [
  CommonModule, FormsModule, MaterialModule, TranslocoModule
];

@NgModule({
  declarations: [DateTimePipe],
  imports: modules,
  exports: [...modules, DateTimePipe]
})
export class SharedModule {
}
